const ACTIONS = {
    JOIN: 'join',
    CODE_CHANGE: 'code_change',
    SYNC_CODE: 'sync_code',
    JOINED: 'joined',
    DISCONNECTED: 'disconnected',
};


export default ACTIONS;